import { jsx as r } from "react/jsx-runtime";
import { useRef as c, useState as m, useEffect as _ } from "react";
import { c as i } from "../clsx-OuTLNxxd.js";
import { T as u, b as C, h as j, g as p, a as B, d as y, c as f, e as h } from "../Table-BJzvuSeE.js";
import '../GridTable.css';const N = "_gridTableWrapper_1o3jj_274", R = "_gridTable_1o3jj_274", W = "_gridTableRow_1o3jj_284", G = "_gridTableColumn_1o3jj_288", M = "_gridTableCaption_1o3jj_291", w = "_gridTableHeader_1o3jj_292", F = "_gridTableBody_1o3jj_293", H = "_gridTableFooter_1o3jj_294", x = "_gridTableCell_1o3jj_298", E = "_fullWidthMobile_1o3jj_301", v = "_hasMultipleTableBodies_1o3jj_310", O = "_mainColumn_1o3jj_345", o = {
  gridTableWrapper: N,
  gridTable: R,
  gridTableRow: W,
  gridTableColumn: G,
  gridTableCaption: M,
  gridTableHeader: w,
  gridTableBody: F,
  gridTableFooter: H,
  gridTableCell: x,
  fullWidthMobile: E,
  hasMultipleTableBodies: v,
  mainColumn: O
}, d = ({ children: e, className: l, label: a, mobileColumns: s, ...n }) => {
  const t = c(null), [b, T] = m(1);
  return _(() => {
    if (t.current) {
      const g = t.current.getElementsByClassName(o.gridTableBody);
      T(g.length);
    }
  }, []), /* @__PURE__ */ r(
    "div",
    {
      "aria-label": a,
      className: o.gridTableWrapper,
      "data-cxy-name": "grid-table",
      style: {
        "--gridWidth": b + 1,
        ...b === 1 ? { gridTemplateColumns: "auto" } : {},
        "--mobileColumns": s
      },
      children: /* @__PURE__ */ r(
        u,
        {
          className: i(o.gridTable, l, {
            [o.hasMultipleTableBodies]: b > 1
          }),
          ref: t,
          ...n,
          children: e
        }
      )
    }
  );
}, S = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(j, { className: i(o.gridTableRow, l), ...a, children: e }), k = ({ children: e, className: l, isMain: a, ...s }) => /* @__PURE__ */ r(
  y,
  {
    className: i(
      o.gridTableColumn,
      {
        [o.mainColumn]: a
      },
      l
    ),
    ...s,
    children: e
  }
), q = ({
  children: e,
  className: l,
  isFullWidthMobile: a,
  isMain: s,
  order: n,
  start: t,
  ...b
}) => /* @__PURE__ */ r(
  f,
  {
    className: i(
      o.gridTableCell,
      {
        [o.fullWidthMobile]: a,
        [o.mainColumn]: s
      },
      l
    ),
    style: { "--cellOrder": n, "--start": t },
    ...b,
    children: e
  }
), z = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(h, { ...a, className: i(o.gridTableFooter, l), children: e }), A = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(p, { ...a, className: i(o.gridTableHeader, l), children: e }), D = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(B, { className: i(o.gridTableBody, l), ...a, children: e }), I = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(C, { className: i(o.gridTableCaption, l), ...a, children: e });
d.Caption = I;
d.Row = S;
d.Head = A;
d.Body = D;
d.Column = k;
d.Cell = q;
d.Footer = z;
export {
  d as GridTable
};
